/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.email.ownership.rpc.ownedaddress.OwnedAddressRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const listOwnedAddressesRpc = {
  serviceName: 'com.hubspot.email.ownership.rpc.ownedaddress.OwnedAddressRpc',
  rpcName: 'listOwnedAddresses',
  auth: 'app',
  fingerprint: 'ID41mQK9OhcFNDWIzgcpC5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getOwnedAddressRpc = {
  serviceName: 'com.hubspot.email.ownership.rpc.ownedaddress.OwnedAddressRpc',
  rpcName: 'getOwnedAddress',
  auth: 'app',
  fingerprint: '4V5kR3GxgDdwNUBQGDITm5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getOwnedAddressesRpc = {
  serviceName: 'com.hubspot.email.ownership.rpc.ownedaddress.OwnedAddressRpc',
  rpcName: 'getOwnedAddresses',
  auth: 'app',
  fingerprint: 'OJ6xCknaE7YaINAXbfViTpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const isVerifiedRpc = {
  serviceName: 'com.hubspot.email.ownership.rpc.ownedaddress.OwnedAddressRpc',
  rpcName: 'isVerified',
  auth: 'app',
  fingerprint: 'KrvdzCDmIjtlijCX06EUcJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const isVerifiedBatchRpc = {
  serviceName: 'com.hubspot.email.ownership.rpc.ownedaddress.OwnedAddressRpc',
  rpcName: 'isVerifiedBatch',
  auth: 'app',
  fingerprint: 'H95kZeolv4J1CQVLkLNUiJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createOwnedAddressRpc = {
  serviceName: 'com.hubspot.email.ownership.rpc.ownedaddress.OwnedAddressRpc',
  rpcName: 'createOwnedAddress',
  auth: 'app',
  fingerprint: 'Qciq_eoz9iwKdHkQ4DSOPZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteOwnedAddressRpc = {
  serviceName: 'com.hubspot.email.ownership.rpc.ownedaddress.OwnedAddressRpc',
  rpcName: 'deleteOwnedAddress',
  auth: 'app',
  fingerprint: 'W7L1r9DuR-I8wJeCGr_zr5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const sendValidationEmailRpc = {
  serviceName: 'com.hubspot.email.ownership.rpc.ownedaddress.OwnedAddressRpc',
  rpcName: 'sendValidationEmail',
  auth: 'app',
  fingerprint: 'RRtTJXC_SGaZzEwrgrnHNpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};